import { render, staticRenderFns } from "./staffAdd.vue?vue&type=template&id=b89d34b0&scoped=true&"
import script from "./staffAdd.vue?vue&type=script&lang=js&"
export * from "./staffAdd.vue?vue&type=script&lang=js&"
import style0 from "./staffAdd.vue?vue&type=style&index=0&id=b89d34b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89d34b0",
  null
  
)

export default component.exports